export const businessContextId = 607;
export const siteUserGroupId = 2066;
export const defaultDashboardId = 2940;
